module.exports = __webpack_public_path__ + "static/Tastea5-c93b3b736aab76c07e807912c254df0e.jpg";